import React from "react";
import logo from "../assets/w-logo.png";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      <div className="h-[12px] bg-tahiti w-full "></div>
      <div className="max-w-[1128px]  mx-auto px-[33px] lg:px-8">
        <div className="py-[21px] flex justify-between">
          <div className="w-[80px] h-[29px] md:w-full md:h-full">
            {" "}
            <img src={logo} alt="logo" />{" "}
          </div>
          <div className="flex items-center">
            <div className="font-[14px] leading-[17px] font-[700]">
              {" "}
              <Link to="/home">
                <button className=" w-[64px] md:w-[110px] md:h-[40px] h-[20px] text-[10px] md:text-[14px] lg:h-[40px] bg-tahiti text-[#ffffff] rounded-[6px] rounded-bl-[0] font-[700]">
                  {" "}
                  SHOPPER
                </button>
              </Link>
            </div>
            <div className="pl-[16px] lg:pl-[80px] text-[10px] md:text-[14px] leading-[17px] font-[700]">
              {" "}
              <a href="/merchant.shopazhub.com " target="_blank">
                <button className=" text-tahiti rounded-[6px] rounded-bl-[0] font-[700]">
                  {" "}
                  Merchant
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
